// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postCreateContactBankAccount } from 'services/ContactService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useCreateContactBankAccountMutation = () => {
  return useMutation({
    mutationFn: postCreateContactBankAccount,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 428) {
        logSentryError('Error: useCreateContactBankAccountMutation', error, data)
      }
    },
  })
}
